<div class="attachment-dialog">
        <div class="head">
            <h2>
                Link transaction to invoice
            </h2>
            <img src="../../../assets/images/cross_icon_grey.svg" alt=" " tabindex="0" mat-dialog-close="0" width="24px"
                height="24px">
        </div>
        <div class="body">
            <div class="filter-section">
                <ng-container *ngIf="!isLoading; else searchLoader">
                    <mat-form-field class="transactions-search-field m-search-field">
                        <img src="../../assets/images/search.svg" alt="search" matPrefix />
                        <input class="search-input" matInput placeholder="Search by keyword" autocomplete="off" [(ngModel)]="search"
                            (keyup)="searchHandler()" autocomplete="off">
                        <div matIconSuffix class="clear-date" *ngIf="search">
                            <button class="btn-clear no-button" (click)="clearFilter('search')">
                                <img src="../../../assets/images/cross_icon_grey.svg" height="19px" width="19px" alt=" " />
                            </button>
                        </div>
                    </mat-form-field>
                </ng-container>
                <ng-container *ngIf="!isLoading; else dateLoader" >
                    <mat-form-field class="mat-range-filter">
                        <mat-date-range-picker #picker
                            (closed)="dateRangeFilter(startDate,endDate)"></mat-date-range-picker>
                        <mat-datepicker-toggle matIconPrefix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="maxDate">
                            <input matStartDate formControlName="start" placeholder="Start date" #startDate readonly>
                            <input matEndDate formControlName="end" placeholder="End date" #endDate readonly>
                        </mat-date-range-input>
                        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                        <div matIconSuffix class="clear-date" *ngIf="startDate.value || endDate.value">
                            <button class="btn-clear" (click)="clearFilter('dateRange')">
                                <img src="../../../../assets/images/cross_icon_grey.svg" height="20px" width="20px"
                                    alt=" " />
                            </button>
                        </div>
                    </mat-form-field>
                </ng-container>
            </div>
            <div class="attachment-table-scroll" (scroll)="onTableScroll($event)">
                <table [hidden]="isTableLoading" id="view-table" class="attachment-table" mat-table [dataSource]="dataSource"
                    matSort matSortDisableClear (matSortChange)="sortChange()" matSortActive="bookingDate" matSortDirection="desc">

                    <ng-container matColumnDef="bookingDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="bookingDate">
                            Date
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index">
                                <mat-checkbox [disableRipple]="true" class="mat-green-checkbox-g" [value]="element.transactionId"
                                    (change)="selectionChangeValue($event, element)">
                                    <span class="radio-label">{{element.bookingDate ?
                                    commonService.formateDate(element.bookingDate) : '-'}}</span>
                                </mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="bookingText">
                        <th mat-header-cell *matHeaderCellDef>
                            Description
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.bookingText || '-' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="amount">
                        <th mat-header-cell *matHeaderCellDef >
                            Amount
                        </th>
                        <td mat-cell *matCellDef="let element" [ngClass]="getAmountClass(element.amount)">
                            {{((element.amount)| number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') + ' €'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="countaryparty">
                        <th mat-header-cell *matHeaderCellDef>
                            Counterparty
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.paymentPartner ? (element.paymentPartner.name ? element.paymentPartner.name : '')
                            : '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="bank">
                        <th mat-header-cell *matHeaderCellDef>
                            Bank account
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.bank ? element.bank : '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="linked">
                        <th mat-header-cell *matHeaderCellDef>
                            Linked
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.isInvoiceLinked; else noLink">
                                <img src="../../../../assets/images/check_icon.svg" alt=" " width="20px"
                                    height="20px">
                            </ng-container>
                            <ng-template #noLink>
                                <img src="../../../../assets/images/info_icon_orange.svg" alt=" " width="20px"
                                    height="20px">
                            </ng-template>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"
                        [ngClass]="{ 'selected-invoice-row' : selectedTransactionIds.indexOf(row.transactionId) > 1 }"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell no-row no-row-transaction no-row-invoice" colspan="6" style="padding:1rem;">
                            <div class="no-transaction-found-container">
                                <img src="../../../../assets/images/invoice_empty_icon.svg" alt="no-invoice">
                                <div class="text-section">
                                    <div class="heading">No Transaction found</div>
                                    <div class="supporting-text">It looks like there are no Transaction found in the linked
                                        accounts. Please check again after sometime.</div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
                <table id="loader-table" *ngIf="isTableLoading" class="attachment-table" mat-table [dataSource]="[1, 2, 3, 4, 5, 6]" matSort  #loaderTable="matSort">
                    <ng-container matColumnDef="bookingDate">
                        <th mat-header-cell *matHeaderCellDef> Date </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="align-loader-name">
                                <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                    width: '24px',
                                    height: '24px',
                                    marginBottom: 0,
                                    marginRight: '12px',
                                    
                                  }">
                                </ngx-skeleton-loader>

                                <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                    width: '160px',
                                    height: '24px',
                                    marginBottom: 0,
                                    
                              }">
                            </ngx-skeleton-loader>
                            </div>
                        </td>
                    </ng-container>
 
                    <ng-container matColumnDef="bookingText">
                        <th mat-header-cell *matHeaderCellDef> Description </th>
                        <td mat-cell *matCellDef="let element">
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                        width: '250px',
                                                        height: '24px',
                                                        marginBottom: 0
                                                      }">
                            </ngx-skeleton-loader>
                        </td>
                    </ng-container>
 
                    <ng-container matColumnDef="amount">
                        <th mat-header-cell *matHeaderCellDef> Amount </th>
                        <td mat-cell *matCellDef="let element">
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                        width: '300px',
                                                        height: '24px',
                                                        marginBottom: 0
                                                      }">
                            </ngx-skeleton-loader>
                        </td>
                    </ng-container>
 
                    <ng-container matColumnDef="countaryparty">
                        <th mat-header-cell *matHeaderCellDef> Counterparty </th>
                        <td mat-cell *matCellDef="let element">
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                        width: '100px',
                                                        height: '24px',
                                                        marginBottom: 0
                                                      }">
                            </ngx-skeleton-loader>
                        </td>
                    </ng-container>
 
                    <ng-container matColumnDef="bank">
                        <th mat-header-cell *matHeaderCellDef> Bank account </th>
                        <td mat-cell *matCellDef="let element">
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                        width: '100px',
                                                        height: '20px',
                                                        marginBottom: 0,
                                                      }">
                            </ngx-skeleton-loader>
                        </td>
                    </ng-container>
 
                    <ng-container matColumnDef="linked">
                        <th mat-header-cell *matHeaderCellDef> Linked</th>
                        <td mat-cell *matCellDef="let element">
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                        width: '24px',
                                                        height: '24px',
                                                        marginBottom: 0
                                                      }">
                            </ngx-skeleton-loader>
                        </td>
                    </ng-container>
 
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
            <ng-container *ngIf="scrollTableLoading">
                <div class="comment-loader">
                    <img src="../../../../assets/images/lazy_loading_spinner.svg" alt="spiner-loader"/>
                </div>
            </ng-container>
        </div>
        <div class="footer">
            <ng-container *ngIf="!isLoading else buttonLoader">
                <button class="cancel" mat-dialog-close="0">
                    Cancel
                </button>
            </ng-container>
            <ng-container *ngIf="!isLoading else buttonLoader">
                <button class="attach" [ngClass]="{ 'disabled-btn': selectedTransactionIds.length == 0 || attachementLoading}" [disabled]="(selectedTransactionIds.length == 0 || attachementLoading)" (click)="linkTransaction()">
                    Attach
                </button>
            </ng-container>
        </div>
</div>

<ng-template #searchLoader>
    <div class="m-search-field">
        <ngx-skeleton-loader count="1" appearance="line" [theme]="{
            width: '400px',
            height: '38px',
            marginBottom: 0
        }"></ngx-skeleton-loader>
    </div>
</ng-template>

<ng-template #buttonLoader>
    <ngx-skeleton-loader count="1" appearance="line" [theme]="{
        width: '145px',
        height: '44px',
        marginBottom: 0
    }"></ngx-skeleton-loader>
</ng-template>
<ng-template #dateLoader>
    <ngx-skeleton-loader count="1" appearance="line" [theme]="{
            width: '278px',
            height: '38px',
            marginBottom: 0
        }"></ngx-skeleton-loader>
</ng-template>